import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {CountryAndTimezoneService} from '@app/shared/services/country-timezone/country-and-timezone.service';
import {MessageTranslateService} from '@shared/services';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CountrySelectComponent), multi: true}],
  standalone: false
})
export class CountrySelectComponent implements OnInit, ControlValueAccessor {

  @Input() placeholder: string;
  @ViewChild('aceSelect', { static: true }) private aceSelect: AceSelectComponent;
  countries: Readonly<string[]> =  this.countryTimezoneService.COUNTRIES;
  selectedCountry: string;
  private onChange: (_) => void = (_) => {};
  private onTouched: () => void = () => {};

  constructor(private translateService: MessageTranslateService,
              private countryTimezoneService: CountryAndTimezoneService) {
  }

  ngOnInit() {
    if (this.placeholder === undefined) {
      this.placeholder = this.translateService.instant('Select Time Zone');
    }

    this.aceSelect.registerOnChange(this.aceSelectChange);
    this.aceSelect.registerOnTouched(this.aceSelectTouched);
  }

  writeValue(value: any): void {
    this.selectedCountry = value;
    this.aceSelect.writeValue(value);
  }

  aceSelectChange = (selected: string) => {
    this.onChange(selected);
  }

  aceSelectTouched = () => {
    this.onTouched();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

}
